import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { useLocale } from '../contexts/LocaleContext';

interface CreditsExplanationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CreditsExplanationModal: React.FC<CreditsExplanationModalProps> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useLocale();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('whats_a_credit')}</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-4 pt-4 text-left">
              <div className="text-left">
                {t('credits_explanation_intro')}
              </div>
              <div className="space-y-2 text-left">
                <div className="font-medium text-left">{t('credits_usage_examples')}</div>
                <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground text-left">
                  <li className="text-left">{t('credit_example_synonym')}</li>
                  <li className="text-left">{t('credit_example_analysis')}</li>
                  <li className="text-left">{t('credit_example_consumption')}</li>
                </ul>
              </div>
              <div className="text-sm text-muted-foreground text-left">
                {t('credits_monthly_allowance')}
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end pt-4">
          <Button
            onClick={() => onOpenChange(false)}
            variant="outline"
            className="bg-card text-foreground border-border hover:bg-muted"
          >
            {t('got_it')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

